import React, { useContext } from "react";
import FixelDataContext from "../../../context/FixelDataContext";
import { StyledP, StyledSelectOptions } from "../setup.style";
import FBLoginButton from "./FBLoginButton";
import SelectOptions from "./SelectOptions";

const FBConnectedAccount = ({ setFBState, FBState }) => {
    const { fullFixelData } = useContext(FixelDataContext);

    const renderAccount = () => {
        return (
            <>
                <StyledSelectOptions>
                    <SelectOptions
                        label="Selected Ad Account:"
                        htmlFor="adAccount"
                        isRequired={false}
                        defaultValue={
                            fullFixelData.facebook.audience[0].account_name ||
                            fullFixelData.facebook.audience[0].account
                        }
                        isError={false}
                        errorMsg=""
                        options={[]}
                        value={
                            fullFixelData.facebook.audience[0].account_name ||
                            fullFixelData.facebook.audience[0].account
                        }
                        disabled={true}
                    />
                    <SelectOptions
                        label="Selected Pixel:"
                        htmlFor="pixel"
                        isRequired={false}
                        defaultValue={
                            fullFixelData.facebook.audience[0].pixel_name ||
                            fullFixelData.facebook.audience[0].pixel
                        }
                        isError={false}
                        errorMsg=""
                        options={[]}
                        value={
                            fullFixelData.facebook.audience[0].pixel_name ||
                            fullFixelData.facebook.audience[0].pixel
                        }
                        disabled={true}
                    />
                </StyledSelectOptions>
                {FBState.connectionFailed ? (
                    <StyledP>The connection to Facebook failed, please try again</StyledP>
                ) : null}
                <FBLoginButton setFBState={setFBState} FBState={FBState} label="Edit" />
            </>
        );
    };

    return renderAccount();
};

export default FBConnectedAccount;
